import { Partner, ProfileTypes, PartnerUser, Site, CitizenChecks, Core, User, HousingReadiness } from "..";
import { EntityType } from "./core";

export interface Header {
    id: string;
    username: string;
    displayName: string;
    networkId: string;
    assignedCareProvider?: Partner.Header;
    assignedSite?: Site.Header;
    assignedCaseworker?: PartnerUser.Header;
    registeredAt: Date;
    housingReadinessLocation?: HousingReadiness.Location;
    housingReadinessType?: HousingReadiness.Type;
    programs: string[];
}

export interface Citizen extends Header {
    profile: Profile;

    attachments: {[key in AttachmentType]?: Core.Document};

    activeApplications: ActiveApplication[];
    keyDocuments: {[key in string]?: KeyDocument};
    
    checks: CitizenChecks.Checks;

    assignedAmbassador?: string;

    preferences: {
        needs: string[];
        demographics: string[];
        notifications: NotificationPreferences;
    }

    hmisId?: string;
}

export interface Profile {
    firstName: string;
    middleName?: string;
    lastName: string;
    email?: string;
    phoneNumber?: string;
    sex?: ProfileTypes.Sex;
    race?: ProfileTypes.Race;
    dateOfBirth: number;
    socialSecurityNumber?: string;
}

export interface ActiveApplication {
    id: string;
    type: EntityType;
    createdAt: Date;
    status: string;
}

export enum AttachmentType {
    SIGNATURE = "SIGNATURE",
    VERIFICATION_SELFIE = "VERIFICATION_SELFIE",
    
    BIRTH_RECORD = "BIRTH_RECORD",
    SOCIAL_SECURITY = "SOCIAL_SECURITY",
    STATE_ID = "STATE_ID",
    VETERAN_ID = "VETERAN_ID",
    GEORGIA_DFCS_BENEFITS = "GEORGIA_DFCS_BENEFITS",
}

export interface NotificationPreferences extends User.NotificationPreferences {
    email?: string;
    sms?: string;
}

export type KeyDocumentType = "BIRTH_RECORD"|"SOCIAL_SECURITY"|"STATE_ID"|"VETERAN_ID"|"GEORGIA_DFCS_BENEFITS";

export interface KeyDocument {
    status: "UNKNOWN"|"NOT_REQUIRED"|"ALREADY_HAS"|"REQUIRED"|"APPLIED"|"OBTAINED";
    application?: ActiveApplication;
    attachments: Core.Document[];
};